module.exports = __webpack_public_path__ + "static/media/1-4.ba24cbd3.webp";